var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":"https://trade.mql5.com/trade?demo_all_servers=1&servers=FXView-Live,FXView-Live;trade_server=FXView-Demo;startup_mode=create_demo;lang=en&save_password=off;utm_source=www.fxview.com","allowfullscreen":"allowfullscreen"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf64158","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fxView/tradingAccounts/web_trade_link_live.vue
// module id = null
// module chunks = 